import { Phone, Mail } from "../../../lib/constants/globalConstant";

const privacyData = {
    updatedOn: "1st November, 2024",
    title: "Privacy Policy",
    description: "This Privacy Policy outlines how we handle your personal information when you purchase tokens, receive rewards, and use our services.",
    sections: [
        {
            title: "1. Information We Collect",
            content:
                "When you use our services to purchase tokens and earn rewards, we may collect certain personal information directly from you, including:",
            list: [
                `<strong>Name:</strong> Used for account identification and personalisation.`,
                `<strong>Email Address:</strong> Used for sending account alerts, updates, and promotional offers.`,
                `<strong>Phone Number:</strong> Used for account-related alerts via text message.`,
            ]
        },
        {
            title: "2. Purpose of Data Collection",
            content: "We use the collected information to provide, maintain, and improve our services. Specifically, we may use your information for:",
            list: [
                `Facilitating token purchases and managing your rewards program.`,
                `Sending account-related alerts, updates, and notifications via text messages and emails.`,
                `Providing customer support and responding to your inquiries.`,
                `Conducting research and analysis to improve the user experience.`,
                `Complying with legal obligations and preventing fraudulent activity.`,
            ],
        },
        {
            title: "3. Consent for Communications",
            content: "By providing your contact information, you consent to receive account-related alerts and updates through text messages and emails. You can manage your communication preferences in your account settings, and you may opt out of non-essential communications at any time.",
        },
        {
            title: "4. Sharing of Information with Third Parties",
            content:
                "We do not sell, rent, or share your personal information with third parties for their marketing purposes. However, we may share your data with trusted third-party service providers who assist us with:",
            list: [
                "Payment processing and order fulfilments.",
                "Email and text message communication services.",
                "Data analysis and research to improve our services."
            ],
            subContent: "These third parties are bound by confidentiality agreements and are only permitted to use your information for the purposes outlined in this Privacy Policy."
        },
        {
            title: "5. Data Security",
            content:
                "We employ industry-standard security measures to protect your personal information from unauthorised access, disclosure, or misuse. While we strive to protect your data, no security measure is infallible, and we cannot guarantee absolute security.",
        },
        {
            title: "6. Data Retention",
            content:
                "We retain your personal information only as long as necessary to fulfil the purposes outlined in this Privacy Policy or as required by law. If you choose to close your account, we will delete or anonymise your data, except as necessary to comply with legal obligations.",
        },
        {
            title: "7. Changes to This Privacy Policy",
            content:
                "We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. We encourage you to review this Privacy Policy regularly to stay informed about how we are protecting your information. Any changes will be posted on this page with an updated effective date.",
        },
        {
            title: "8. Contact Us",
            content:
                `If you have any questions about this Privacy Policy, you can contact us:`,
            list: [
                `By emailing us at <a href="mailto:${Mail}" target="_blank" class="text-primaryHeading">${Mail}</a>`,
                `By calling us at <a href="tel:+${Phone}" target="_blank" class="text-primaryHeading">${Phone}</a>`,
            ],
        },
    ],
};

export default privacyData;
